// Define workspace fields
const WORKSPACE_FIELDS = {
  video_type: 'Video Type',
  description: 'Description',
  description_status: 'Description Status',
  duration_minutes: 'Duration (In Minutes)',
  year: 'Year',
  decade: 'Decade',
  country: 'Country',
  region: 'Region',
  cast: 'Cast',
  imdb_id: 'IMDB ID',
  UUID: 'UUID',
  date_creation: 'Date Creation',
  color: 'Color',
  series_id: 'Series',
  season: 'Season',
  episode_num: 'Episode #',
  genres: 'Genres',
  plot_keywords: 'Keywords',
  collection_id: 'Collections',
  trashy: 'Trashy',
  good_bad: 'Good/Bad',
  pnm_exclusives: 'Exclusives',
  five_star_rating: '5 Star Rating',
  offline: 'Offline',
  offline_reason: 'Offline Reason',
  mpaa_rating: 'MPAA Rating',
  restricted_content: 'Restricted Content',
  restricted_content_reason: 'Restricted Content Reason',
  restricted_content_source: 'Restricted Content Source',
  exclude_from_db: 'Exclude From DB',
  date_license_expiration: 'Date License Expiration',
  ad_timing_status: 'Ad Timing Status',
  genre_status: 'Genre Status',
  duplicate_imdb: 'Duplicate IMDB Check',
  quality_video: 'Video URL Check',
  quality_poster_16x9: 'Poster URL Check',
  quality_trailer: 'Trailer URL Check',
  video_status: 'Video Status',
  video_encoded_status: 'Video Encoded Status',
  video_status_reason: 'Video Status Reason',
  video_status_reason_details: 'Video Status Details',
  trailer_status: 'Trailer Status',
  trailer_encoded_status: 'Trailer Encoded Status',
  trailer_status_reason: 'Trailer Reason',
  tvod: 'TVOD Street Date',
  tvod_enabled: 'TVOD License',
  svod_enabled: 'SVOD License',
  tvod_iap: 'TVOD Price',
  svod: 'SVOD Street Date',
  avod: 'AVOD Street Date',
  avod_validated: 'AVOD License',
  avod_watched: 'AVOD Watched (In Minutes)',
  avod_watched_7: 'AVOD Weekly Watched (In Minutes)',
  svod_watched: 'SVOD Watched (In Minutes)',
  ad_timing: 'Ad Timing',
  ad_timing_detected: 'Auto-detected Ad Times',
  distributor_sku: 'Distributor SKU',
  distributor_type: 'Distributor Type',
  distributor_id: 'Distributor Name',
  contract_no: 'Contract Number',
  royality: 'Royality',
  public_domain: 'Public Domain',
  custom_royality: 'Custom Royality',
  schedule_priority: 'Priority Schedule',
  geofencing_allow: 'Geofencing Allow',
  geofencing_deny: 'Geofencing Deny',
  always_published: 'Always Published',
  trailer_url: 'Trailer URL',
  video_url: 'Video URL',
  poster_16x9_url: 'Poster 16x9 URL',
  poster_16x9_status: 'Poster 16x9 Status',
  subtitle_en_url: 'Subtitle EN URL',
  mm_notes: 'MM Notes',
  ms_notes: 'MS Notes',
  imdb_duration_minutes: 'IMDB Duration',
  imdb_language: 'IMDB Language',
  imdb_year: 'IMDB Year',
  imdb_plot_keywords: 'IMDB Keywords',
  imdb_directors: 'IMDB Directors',
  imdb_writers: 'IMDB Writers',
  imdb_cast: 'IMDB Cast',
  imdb_country: 'IMDB Country',
  imdb_description: 'IMDB Description',
  fhNotes: 'Notes',
  distributorSkuSeries: 'Distrubutor Series SKU',
  videoLanguage: 'Language',
};

export default WORKSPACE_FIELDS;
